const { defaultLanguage } = require('../i18n/settings');

const localizeUrl = (language, url, defaultLangKey = defaultLanguage) => {
    return `/${language}${url}`.replace(`/${defaultLangKey}`, '');
};

module.exports = { localizeUrl };
